import ErrorPage from '@/pages/error';
import { SentryService } from '@/services/sentry';
import { environmentManager } from '@tanstack/react-query';
import type { ErrorComponentProps } from '@tanstack/react-router';
import { type FC, memo, useEffect } from 'react';

const ErrorBoundary: FC<ErrorComponentProps> = memo(({ error, reset }) => {
  if (environmentManager.isServer()) {
    // eslint-disable-next-line no-console
    console.error(error);
  }

  useEffect(() => {
    SentryService.trackError(error);
  }, [error]);

  return <ErrorPage reset={reset} />;
});

export default ErrorBoundary;
